import { AUT_DOCUMENTATION_LINK, CONTENT } from 'modules/anonymousUserTracking/constants';
import { ListEmptyTableState, NoResult } from 'ui/illustrations';
import { Link } from 'ui/links';
import { H4 } from 'ui/theme';
import { EmptyStateBody, ExpandingWrapper, SecondaryText } from '../AnonymousUserTracking.styled';

const {
  defaultEmptyTitle,
  defaultEmptyBody,
  defaultEmptyLinkLabel,
  filteredEmptyTitle,
  filteredEmptyBody,
} = CONTENT.emptyState;

export const EmptyState = ({ filterApplied = false }: { filterApplied?: boolean }) => {
  const Illustration = filterApplied ? NoResult : ListEmptyTableState;
  return (
    <ExpandingWrapper>
      <Illustration />
      <H4>{filterApplied ? filteredEmptyTitle : defaultEmptyTitle}</H4>
      <EmptyStateBody>
        {filterApplied ? (
          filteredEmptyBody
        ) : (
          <SecondaryText>
            {defaultEmptyBody}{' '}
            <Link size="body1" href={AUT_DOCUMENTATION_LINK}>
              {defaultEmptyLinkLabel}
            </Link>
            .
          </SecondaryText>
        )}
      </EmptyStateBody>
    </ExpandingWrapper>
  );
};
